export const getSiteHeaderHeight = () => {
	return ($ => {
		let siteHeaderHeight = $('#site-header').outerHeight();
		const $adminBar = $('#wpadminbar');
		const $anchorItems = $('.fullWidthHero-anchorNavItems.fixed');
		const $targetElement = $( $( event.currentTarget ).attr( 'href' ) );

		if( $adminBar.size() ) {
			siteHeaderHeight = siteHeaderHeight + $adminBar.outerHeight();
		}

		if( $anchorItems.size() ) {
			siteHeaderHeight = siteHeaderHeight + $anchorItems.outerHeight();
		}

		return siteHeaderHeight;
	})(jQuery);
};

export const scrollTo = ($targetElement, duration=500, options={}) => {
	return ($ => {
		$( window ).scrollTo( $targetElement, duration, {
			...options,
			offset: ( Foundation.MediaQuery.atLeast('medium') ? getSiteHeaderHeight() * -1 : 0 ) + ( options.offset || 0 )
		});

		$targetElement.attr( 'tabindex', '0' );

		setTimeout( () => {
			$targetElement.focus();
		}, 100);
	})(jQuery);
};



// WEBPACK FOOTER //
// ../benetech/js/utilities.js